<template>
  <div class="ven-cfg-inter">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <!-- SETA O FILTROS E O BOTÃO NOVO CONTATO -->
      <div class="cabecalho">
        <App-Filtros
        :cpntMontarCampoF="venCfgTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="venCfgTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="venCfgTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'nome', o: '%', v: '' }"
        :cpntInputCoringa="{}"
        @BUSCAR='venCfgTabBuscarLinhas'
        ref="filtros">
          <App-Button :data-time="time" 
            :cpntId='botao.id'
            :cpntStatus='botao.status' 
            :cpntIcone='botao.icone'
            :cpntTexto='botao.texto'
            :cpntClass='botao.class'
            :cpntDisabled="botao.disabled"
            @onClick='botao.onClick'
          ></App-Button>
        </App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntSetarFiltros="venCfgTabSetarFiltros"
        :cpntMontarFiltros="venCfgTabMontarFiltros"
        :cpntMontarWhere="venCfgTabTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntBotaoEditar="botaoEditar"
        :cpntBotaoExcluir="botaoExcluir"
        :cpntSetarValores="venCfgTabSetarLinhas"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiOrder="order"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @TABELA_MARCAR_CHECKBOX='venCfgTabMarcarCheckbox'
        ref="tabela">
          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_last="{ linha }">
            <span v-html="linha.last_user_usuario + '<br/>' + linha.last_at_ptbr"></span>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view :cpntFecharFormulario="venCfgTabFecharFormulario"></router-view>
  </div>
</template>

<style scoped>
.ven-cfg-inter {
  max-width: 840px;
}
  .ven-cfg-inter > .cabecalho > .cpnt-filtro-base {
    margin-top: 10px !important;
  }
</style>

<style>
</style>

<script>
  export default {
    components: {
      'App-Filtros': () => import('@/components/_geral/Filtros.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        checkbox: [],
        route: '/venda/config/intermediador/get',
        method: 'POST',
        botao: {
          status: '',
          texto: 'Novo intermediador',
          class: [ 'btn', 'btn-info' ],
          mostrar: true,
          onClick: () => { this.$router.push({ name: 'venda_config_intermediador_form', params: { id: 0 } }) }
        },
        colunas: [],
        linha: [],
        where: {},
        order: { last_at: 'desc' },
        estruturaQueryGet: [ [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ] ],
        botaoEditar: undefined,
        botaoExcluir: undefined,
        botaoReativar: undefined
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.venCfgTabSetarStatusGeral('carregando')

      // INICIA O CARREGAMENTO DA TELA
      this.venCfgTabBuscarLinhas()
    },
    methods: {
      venCfgTabFecharFormulario: function (atualizar) {
        if (atualizar === true) {
          this.venCfgTabBuscarLinhas()
        }
      },
      venCfgTabBuscarLinhas: function () {
        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoEditar = null
        this.botaoExcluir = null

        // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, [ 2 ], null, [ 105 ], null, false) === true) {
          this.botaoEditar = this.venCfgTabEditar
        }

        // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 21 ], null, [ 2 ], null, [ 106 ], null, false) === true) {
          this.botaoExcluir = this.venCfgTabExcluir
        }

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }
        
        // REINICIA O VALOR DO CAMPO
        this.fazerOrdenacao = true

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 3, chave: 'id',                                                 fieldsApi: { id: null }, tipo: 'checkbox' },
          { mPer: 2, chave: 'id',                 nome: 'Cód.',                   fieldsApi: { id: null } },
          { mPer: 2, chave: 'nome',               nome: 'Nome',                   fieldsApi: { nome: null } },
          { mPer: 2, chave: 'cnpj',               nome: 'Nome',                   fieldsApi: { cnpj: null } },
          { mPer: 2, chave: 'usu_intermediador',  nome: 'Usuário Intermediador',  fieldsApi: { usu_intermediador: null } },
          { mPer: 2, chave: 'last',               nome: 'Última Alteração',       fieldsApi: { last_at: null, last_user: { j: { usuario: null } } } }
        ]

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
          this.venCfgTabReiniciar()
        } else {
          this.venCfgTabSetarStatusGeral('')
        }
      },
      venCfgTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      venCfgTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.venCfgTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      venCfgTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.venCfgTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      venCfgTabMontarFiltros: function (callback, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.venCfgTabMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      venCfgTabSetarLinhas: function (vetor) {
        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          vetor[index].cnpj = vetor[index].cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
        }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      venCfgTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      venCfgTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = { fazerOrdenacao: true }
        
        // CONVERTE A OPERAÇÃO RECEBIDA
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'nome':
            retorno.where = Object.assign(where, { f: 'nome' })
            break

          case 'cnpj':
            retorno.where = { f: 'cnpj', o: where.o, v: where.v.replace(/\D/g, '') }
            break

          case 'busca':
            // SETA OS DADOS QUE DEVE BUSCAR
            retorno.where = { o: 's.ft', v: where.v }

            // REINICIA O VALOR DO CAMPO
            this.fazerOrdenacao = false
            break
        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      venCfgTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          { id: 'nome', nome: 'Nome' },
          { id: 'cnpj', nome: 'CNPJ' }
        ]

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      venCfgTabOnBuscarOptionsFiltroO: function (callback, vetor) {
        // INICIA O VETOR PARA OS CAMPOS
        var seletor = {}

        // VE O QUE DEVE COLOCAR NOS CAMPOS
        switch (vetor.f) {
          case 'nome':
            seletor.options = [
              { id: '%', nome: '% Contém', _formatar: [ 'id' ] }
            ]
            break

          case 'cnpj':
            seletor.options = [
              { id: '=', nome: '= Igual', _formatar: [ 'id' ] }
            ]
            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(seletor)
      },
      venCfgTabOnBuscarOptionsFiltroV: function (callback, vetor) {
        // INICIA O VETOR PARA OS CAMPOS
        var seletor = {}

        // VE O QUE DEVE COLOCAR NOS CAMPOS
        switch (vetor.f + '_' + vetor.o) {
          case 'nome_%':
            seletor.tipo = 'input'
            break

          case 'cnpj_=':
            // SETA O TIPO DO CAMPO
            seletor.tipo = 'input'

            // SETA A MASCARA QUE DEVE UTILIZAR NO CAMPO
            seletor.mask = 'cnpj'
            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(seletor)
      },
      venCfgTabEditar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (this.checkbox.length >= 2) {
          this.$store.state.msgWarn('WEB [406]: Só é possivel editar um contato de cada vez.', 'warning')
        } else {
          // SETA OS IDS QUE DEVE EDITAR
          var ids = this.checkbox.length === 1 ? this.checkbox[0] : window.btoa(JSON.stringify(this.checkbox))

          // REDIRENCIONA PARA TELA SOLICITADA
          this.$router.push({ name: 'venda_config_intermediador_form', params: { id: ids } })
        }
      },
      venCfgTabExcluir: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente excluir o(s) intermediario(s) selecionado(s)?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { lot: [] }

          // ADICIONA OS IDS NO VETOR PARA EXCLUIR
          for (var indexC in this.checkbox) {
            formData.lot.push({ id: this.checkbox[indexC] })
          }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/venda/config/intermediador', 'DELETE', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // MANDA ATUALIZAR A TABELA
                this.venCfgTabBuscarLinhas()
                break

              default:
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoExcluir = this.venCfgTabExcluir

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.venCfgTabSetarStatusGeral)
        }
      },
    }
  }
</script>
